module.exports = __webpack_public_path__ + "img/Xing_Xu@2x.9e0c58ef.png";